import type { GetOutput } from '@jwplayer/companion-gateway';
import { Store } from '@jwplayer/fe-common/module/store/react';

export const SessionStore = new Store<{
  session: GetOutput<'dashboard-scope', 'read'> | undefined;
  currentSiteId: string | undefined;
  accountLimits: {
    isStreamingStopped: boolean;
    isStorageStopped: boolean;
    isAdsStopped: boolean;
  };
}>({
  session: undefined,
  currentSiteId: undefined,
  accountLimits: {
    isStreamingStopped: false,
    isStorageStopped: false,
    isAdsStopped: false,
  },
});
